import { EventService } from "../../_service/event.service";

export default async function joinEventLiveCall(event: any) {
    try {
        const meetingUrl = await EventService.createEventLink(event.liveCall.meetingId);
        if (meetingUrl) {
          window.open(meetingUrl, "_blank");
        }
      } catch (error: any) {
        console.error("Error joining meeting:", error.message);
      }
  }